/**
 * Product detail page — variant selection, gallery, quantity, add to cart.
 * Ported from the prototype's assets/js/product.js, wired to the real
 * Shopify product/variant data and the AJAX Cart API.
 */
(function () {
  "use strict";

  var routes = (window.Pawello && window.Pawello.routes) || {};

  function initProductForm(root) {
    var variantsData = root.querySelector("[data-product-variants]");
    var optionNamesData = root.querySelector("[data-product-option-names]");
    var variants = [];
    var optionNames = [];
    try {
      variants = JSON.parse(variantsData.textContent);
      optionNames = JSON.parse(optionNamesData.textContent);
    } catch (e) {
      variants = [];
      optionNames = [];
    }

    var optionButtons = root.querySelectorAll("[data-option-value]");
    var selected = {};
    optionButtons.forEach(function (btn) {
      if (btn.classList.contains("is-active")) {
        selected[btn.dataset.optionName] = btn.dataset.optionValue;
      }
    });

    var priceEl = root.querySelector("[data-product-price]");
    var comparePriceEl = root.querySelector("[data-product-compare-price]");
    var addBtn = root.querySelector("[data-add-to-cart]");
    var variantIdInput = root.querySelector("[data-variant-id]");
    var gallery = document.querySelector("[data-gallery]");

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (optValue, idx) {
          return selected[optionNames[idx]] === optValue;
        });
      });
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace(".", ",");
      return amount + " €";
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.classList.remove("hidden");
        } else {
          comparePriceEl.classList.add("hidden");
        }
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.dataset.labelAvailable;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.labelSoldOut;
        }
      }
      if (variant.featured_media && gallery) {
        setActiveImage(variant.featured_media.id);
      }
      updateAvailability();
    }

    function updateAvailability() {
      optionButtons.forEach(function (btn) {
        var hypothetical = Object.assign({}, selected);
        hypothetical[btn.dataset.optionName] = btn.dataset.optionValue;
        var match = variants.find(function (v) {
          return v.options.every(function (optValue, idx) {
            return hypothetical[optionNames[idx]] === optValue;
          });
        });
        var reachable = !!match && match.available;
        if (btn.tagName === "BUTTON") btn.disabled = !match;
        btn.classList.toggle("is-unavailable", !reachable);
      });
    }

    /* Die Galerie darf NIE ohne aktives Bild dastehen - sonst sieht man nur den
       sandfarbenen Hintergrund des Containers. Findet die gesuchte Media-ID
       kein Bild (z. B. weil die Variante gar kein eigenes Bild hat), bleibt das
       erste Bild aktiv. */
    function selectFirst(mainImgs, thumbs) {
      mainImgs.forEach(function (img, i) {
        img.classList.toggle("is-active", i === 0);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle("is-active", i === 0);
      });
    }

    function setActiveImage(mediaId) {
      var mainImgs = gallery.querySelectorAll("[data-gallery-main-image]");
      var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      if (!mainImgs.length) return;

      var matched = false;
      mainImgs.forEach(function (img) {
        if (String(img.dataset.mediaId) === String(mediaId)) matched = true;
      });

      if (!matched) {
        selectFirst(mainImgs, thumbs);
        return;
      }

      mainImgs.forEach(function (img) {
        img.classList.toggle("is-active", String(img.dataset.mediaId) === String(mediaId));
      });
      thumbs.forEach(function (t) {
        t.classList.toggle("is-active", String(t.dataset.mediaId) === String(mediaId));
      });
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = root.querySelectorAll('[data-option-name="' + btn.dataset.optionName + '"]');
        group.forEach(function (b) {
          b.classList.remove("is-active");
        });
        btn.classList.add("is-active");
        selected[btn.dataset.optionName] = btn.dataset.optionValue;
        var labelTarget = root.querySelector('[data-option-label="' + btn.dataset.optionName + '"]');
        if (labelTarget) labelTarget.textContent = btn.dataset.optionValue;
        updateUI();
      });
    });

    if (gallery) {
      gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          setActiveImage(thumb.dataset.mediaId);
        });
      });
      /* Sicherheitsnetz: falls beim Rendern kein Bild als aktiv markiert wurde. */
      if (!gallery.querySelector("[data-gallery-main-image].is-active")) {
        selectFirst(
          gallery.querySelectorAll("[data-gallery-main-image]"),
          gallery.querySelectorAll("[data-gallery-thumb]")
        );
      }
    }

    var qtyValue = root.querySelector("[data-qty-value]");
    var qtyMinus = root.querySelector("[data-qty-minus]");
    var qtyPlus = root.querySelector("[data-qty-plus]");
    if (qtyMinus && qtyPlus && qtyValue) {
      qtyMinus.addEventListener("click", function () {
        var v = Math.max(1, parseInt(qtyValue.textContent, 10) - 1);
        qtyValue.textContent = v;
      });
      qtyPlus.addEventListener("click", function () {
        var v = parseInt(qtyValue.textContent, 10) + 1;
        qtyValue.textContent = v;
      });
    }

    var form = root.querySelector("[data-product-form-el]");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;

        var quantity = qtyValue ? parseInt(qtyValue.textContent, 10) : 1;
        var variantId = variantIdInput ? variantIdInput.value : form.querySelector('[name="id"]').value;

        addBtn.classList.add("is-loading");

        fetch(routes.cartAddUrl || "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: variantId, quantity: quantity }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function () {
            return fetch((routes.cartUrl || "/cart") + ".js");
          })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            if (window.Pawello && window.Pawello.cart) {
              window.Pawello.cart.updateBadge(cart.item_count);
              window.Pawello.cart.refresh().then(function () {
                window.Pawello.cart.open();
              });
            }
            showToast();
          })
          .catch(function () {})
          .finally(function () {
            addBtn.classList.remove("is-loading");
          });
      });
    }

    updateUI();
  }

  function showToast() {
    var toast = document.querySelector("[data-toast]");
    if (!toast) return;
    toast.classList.add("is-visible");
    window.clearTimeout(window.__pawelloToastTimer);
    window.__pawelloToastTimer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 2400);
  }

  function initRecommendations() {
    var container = document.querySelector("[data-recommendations]");
    if (!container) return;
    var url = container.dataset.url;
    var target = container.querySelector("[data-recommendations-target]");
    if (!url || !target) return;

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var freshTarget = doc.querySelector("[data-recommendations-target]");
        if (freshTarget && freshTarget.innerHTML.trim()) {
          target.innerHTML = freshTarget.innerHTML;
          var parentSection = doc.querySelector(".related-section");
          if (parentSection && container.parentElement) {
            container.querySelectorAll(".reveal, .reveal-stagger").forEach(function (el) {
              el.classList.add("is-visible");
            });
          }
        } else {
          container.style.display = "none";
        }
      })
      .catch(function () {
        container.style.display = "none";
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-product-form]").forEach(initProductForm);
    initRecommendations();
  });
})();
